import React, {useEffect, useMemo, useReducer} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import {AuthContext} from './componentes/context';
import Login from './componentes/Login';
import Registrar from './componentes/Registrar';
import Dashboard from "./componentes/Menu";
import Recuperar from './componentes/Recuperar';

// const createTheme = process.env.NODE_ENV === 'production' ? createMuiTheme : unstable_createMuiStrictModeTheme;

const theme = createTheme({
    palette: {
        primary: {
            light: '#33ab9f',
            main: '#00c2b3', //'#009688',
            dark: '#00695f',
            contrastText: '#fff',
        },
        secondary: {
            light: '#5495e1',
            main: '#0068af',
            dark: '#003e7f',
            contrastText: '#fff',
        },
    },
    typography: {
        // In Chinese and Japanese the characters are usually larger,
        // so a smaller fontsize may be appropriate.
        fontSize: 13,
    },
});

function App() {

    const initialLoginState = {
        isLoading: true,
        userEmail: null,
        userToken: null,
    };

    const loginReducer = (prevState, action) => {
        switch (action.type) {
            case 'RETRIEVE_TOKEN':
                return {
                    ...prevState,
                    userToken: action.token,
                    isLoading: false,
                };
            case 'LOGIN':
                return {
                    ...prevState,
                    userEmail: action.email,
                    userToken: action.token,
                    isLoading: false,
                };
            case 'LOGOUT':
                return {
                    ...prevState,
                    userEmail: null,
                    userToken: null,
                    isLoading: false,
                };
            case 'REGISTER':
                return {
                    ...prevState,
                    userEmail: action.email,
                    userToken: action.token,
                    isLoading: false,
                };
            default:
                return prevState
        }
    };

    // eslint-disable-next-line no-unused-vars
    const [loginState, dispatch] = useReducer(loginReducer, initialLoginState);

    const authContext = useMemo(() => ({
        signIn: async (userData) => {
            const userToken = String(userData.token);
            const userEmail = userData.usuario.email;

            try {
                localStorage.setItem("userToken", userToken);
                localStorage.setItem("userEmail", userEmail);
            } catch (e) {

            }
            dispatch({type: 'LOGIN', email: userEmail, token: userToken});
        },
        signOut: async () => {
            try {
                localStorage.removeItem("userToken");
                localStorage.removeItem("userEmail");
            } catch (e) {
                // process e
            }
            dispatch({type: 'LOGOUT'});
        },
    }), []);

    useEffect(() => {
        setTimeout(async () => {
            let userToken;
            userToken = null;
            try {
                userToken = localStorage.getItem("userToken");
            } catch (e) {
                // process e
            }
            dispatch({type: 'RETRIEVE_TOKEN', token: userToken});
        }, 1000);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <AuthContext.Provider value={authContext}>
                <Router basename={'/conadi/web'}>
                    <Switch>
                        <Route path="/home">
                            <Dashboard/>
                        </Route>
                        <Route path="/registrar">
                            <Registrar/>
                        </Route>
                        <Router path="/recuperar">
                            <Recuperar/>
                        </Router>
                        <Route path="/">
                            <Login/>
                        </Route>
                    </Switch>
                </Router>
            </AuthContext.Provider>
        </ThemeProvider>
    )
}

export default App;
